import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.dashboard');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-admin-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageAdminDashboardComponent implements OnInit, OnDestroy {
    public ru = RU;
    public t: any = RU;
    public stats: any = {};
    public loading: boolean = true;
    public topCategories: any[] = [];
    public recentUsers: any[] = [];
    public trendData: any[] = [];
    public trendDays: number = 14;
    public trendMetric: string = 'dau';
    public trendMax: number = 1;
    private langListener: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.t = getAdminT();
        this.langListener = async () => { this.t = getAdminT(); await this.service.render(); };
        window.addEventListener('admin-lang-change', this.langListener);
        await this.load();
    }

    ngOnDestroy() {
        if (this.langListener) window.removeEventListener('admin-lang-change', this.langListener);
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("stats");
        if (code === 200) {
            this.stats = data.summary || {};
            this.topCategories = (data.top_categories || []).slice(0, 5);
            this.recentUsers = (data.recent_users || []).slice(0, 5);
        }

        this.loading = false;
        await this.service.render();
        await this.loadTrends();
    }

    public async loadTrends() {
        const { code, data } = await wiz.call("trends", { days: this.trendDays });
        if (code === 200) {
            this.trendData = data.trends || [];
            this.updateTrendMax();
        }
        await this.service.render();
    }

    public async changePeriod(days: number) {
        this.trendDays = days;
        await this.loadTrends();
    }

    public async changeMetric(metric: string) {
        this.trendMetric = metric;
        this.updateTrendMax();
        await this.service.render();
    }

    private updateTrendMax() {
        const m = this.trendMetric;
        let max = 0;
        for (const d of this.trendData) {
            if (d[m] > max) max = d[m];
        }
        this.trendMax = max || 1;
    }

    public barHeight(item: any): number {
        const val = item[this.trendMetric] || 0;
        return Math.round((val / this.trendMax) * 100);
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '-';
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('ru-RU', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch {
            return dateStr;
        }
    }
}

export default PageAdminDashboardComponent;